import React, { ReactChild, ReactChildren } from 'react';
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import GlobalNav from '../global-nav';
import Sidenav from '../sidenav';

interface Props {
  layoutTitle?: string,
  maxWidth?: boolean,
  noPadding?: boolean,
  children: ReactChild | ReactChildren,
  navBarComponents?: ReactChild | ReactChildren,
  onSidebarToggle?: () => void,
}

const GlobalContainer = styled(Box)(({ theme }) => ({
  position: 'absolute',
  display: 'flex',
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  backgroundColor: theme.palette.background.paper,
}));

const MainContainer = styled(Box)({
  borderTop: '5px solid #eb1300',
  boxSizing: 'border-box',
  position: 'relative',
  flex: 1,
  width: '100%',
});

const ContentContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'max',
})<{ max?: boolean }>(({ max }) => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  width: '100%',
  maxWidth: max ? '1200px' : undefined,
  marginLeft: 'auto',
  boxSizing: 'border-box',
  marginRight: 'auto',
}));

const MainContainerInner = styled(Box)({
  transition: 'all 0.1s ease-in 0s',
  display: 'flex',
  borderBottom: '1px solid #eee',
  justifyContent: 'right',
});

const ContentWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'noPadding',
})<{ noPadding?: boolean }>(({ theme, noPadding }) => ({
  display: 'flex',
  justifyContent: 'center',
  position: 'absolute',
  left: 0,
  top: 48,
  bottom: 0,
  right: 0,
  overflow: 'auto',
  padding: noPadding ? 0 : 48,

  [theme.breakpoints.down('sm')]: {
    padding: noPadding ? 0 : 24,
  },
  transition: 'left 150ms ease-in-out, right 150ms ease-in-out',
  backgroundColor: theme.palette.background.default,
}));
const NavBarWrapper = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
}));

const justifySpaceBetween = {
  justifyContent: 'space-between',
};

const Layout: React.FC<Props> = ({ maxWidth = true, noPadding = false, ...props }) => (
  <GlobalContainer>
    <Sidenav onNavClick={props.onSidebarToggle} />
    <MainContainer>
      <MainContainerInner sx={props.navBarComponents ? justifySpaceBetween : {}}>
        {props.navBarComponents ? (<NavBarWrapper>{props.navBarComponents}</NavBarWrapper>) : null}
        <GlobalNav />
        <ContentWrapper noPadding={noPadding}>
          <ContentContainer max={maxWidth}>
            {props.layoutTitle && (
              <Typography
                data-testid="layout-title"
                variant="h1"
              >
                {props.layoutTitle}
              </Typography>
            )}
            {props.children}
          </ContentContainer>
        </ContentWrapper>
      </MainContainerInner>
    </MainContainer>
  </GlobalContainer>
);

export default Layout;
